<template>
  <div class="page">
    <el-form inline size="medium">
      <el-form-item>
        <date-time-range-picker :start-time.sync="searchForm.startCreateTime" :end-time.sync="searchForm.endCreateTime"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="load">{{ $t('搜索') }}</el-button>
      </el-form-item>
    </el-form>


    <div class="content">
      <client-stat :data="dataCounts" />
      <user-stat :data="dataCounts" />
      <member-stat :data="dataCounts" />
      <recipe-stat :data="dataCounts" />
      <deal-stat :data="dataCounts" />
    </div>
  </div>
</template>

<script>
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import UserStat from "@/components/stat/UserStat";
import ClientStat from "@/components/stat/ClientStat";
import {request} from "@/config/request";
import MemberStat from "@/components/stat/MemberStat";
import RecipeStat from "@/components/stat/RecipeStat";
import DealStat from "@/components/stat/DealStat";
import _ from "lodash"
export default {
  name: "StatCenter",
  components: {DealStat, RecipeStat, MemberStat, ClientStat, UserStat, DateTimeRangePicker},
  data() {
    return {
      dataCounts: {},
      searchForm: {}
    }
  },
  methods: {
    async load() {
      try {
        const res = await request(this.$api.data.dataCenter, this.searchForm);
        this.dataCounts = res.dataMap;
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.load();
  }
}
</script>

<style scoped>

.page {
  height: 99%;
  display: flex;
  flex-direction: column;
}

.el-form {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 10px 10px 0 10px;
  margin-bottom: 16px;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.content {
  flex: 1;
  overflow: auto;
}

/deep/.content .el-card {
  margin-bottom: 16px;
}

</style>
